module.exports = __webpack_public_path__ + "img/IMAGE 5.d0ce70fa.png";